<template>
    <MainContentSearchable
        title="Listado de emails recopilados de recordatorios"
        id="recordatorios"
        v-model="filters"
        :meta="loading ? {} : recordatorios.meta"
        @updated="debouncedGetRecordatorios"
    >
        <template v-slot:header>
            <div class="col-12">
                <div class="form-group">
                    <label for="eventos">Seleccionar evento</label>
                    <multiselect 
                        placeholder="Seleccionar evento"
                        track-by="id"
                        label="name"
                        v-model="filters.evento_id"
                        :options="eventos"
                        v-on:select="getRecordatorios"
                        v-on:remove="onRemove"
                    >
                        <template slot="noResult">No existe ese evento.</template>
                    </multiselect>
                </div>
            </div>
        </template>
  
        <template v-slot:content v-if="!loading">
            <div v-if="recordatorios.data.length > 0" class="table-responsive has-options">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Email</th>
                            <th>Evento</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(recordatorio, index) in recordatorios.data" >
                            <tr :key="index">
                                <td>{{ recordatorio.nombre }}</td>
                                <td>{{ recordatorio.email }}</td>
                                <td>{{ recordatorio.nombre_evento }}</td>
                                <td>
                                    <Button
                                        type="button"
                                        class="btn btn-danger"
                                        @click="showModal('borrar-' + recordatorio.id)"
                                    >
                                        BORRAR
                                    </Button>
                                </td>
                                <BorrarRecordatorioModal
                                    :recordatorio="recordatorio"
                                    @close="closeModal"
                                />
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <span class="font-weight-bold">
                    No hay recordatorios que coincidan con tu búsqueda
                </span>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from "@/components/backend/components/MainContentSearchable";
    import BorrarRecordatorioModal from "@/components/backend/components/BorrarRecordatorioModal.vue";

    export default {
        data() {
            return {
                recordatorios: [],
                filters: {
                    per_page: 10,
                    page: 1,
                    search: "",
                    evento_id: null,
                },
                loading: true,
                eventos: [],
            };
        },
        created() {
            this.getEvents();
            this.getRecordatorios();  
            this.debouncedGetRecordatorios = _.debounce(this.getRecordatorios, 500); 
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        methods: {
            onRemove(removed) {
                if (this.filters.evento_id) {
                    this.filters.evento_id = null;
                }
            },
            getRecordatorios() {
                const params = {
                    filters: {
                    ...this.filters,
                    tid: this.configuracion.hash_teatro,
                    }
                };

                if(this.filters.evento_id) {
                    params.filters.evento_id = this.filters.evento_id.id
                }

                this.$store
                    .dispatch(
                        this.config.getVuexAlias("back.comunicados.recordatorios.index"),
                        params
                    )
                    .then(res => {
                        this.recordatorios = res.data;
                        this.loading = false;
                    });
            },
            getEvents() {
                this.loading = true;
                const data = {
                    filters: {
                        to_select: true,
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                    this.eventos = res.data;
                }).finally(() => this.loading = false);
            },
            setPage(page) {
                this.filters.page = page;
                this.debouncedGetRecordatorios();
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, borrado) {
                this.$modal.hide(modal);
                if (borrado) {
                    this.this.debouncedGetRecordatorios();
                }
            },
        },
        components: {
            MainContentSearchable,
            BorrarRecordatorioModal,
        },
    };
</script>
